import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    error: null,
    info: null,
    isLogin: false,
    isLoginUser:{
      userName: sessionStorage.getItem('userName'),
    },
    loadingShow:false,
    logoutShow:false,
  },
  mutations: {
    setError(state, message) {
      state.error = message;
    },
    setInfo(state, message) {
      state.info = message;
    },
    clearError(state) {
      state.error = null;
    },
    clearInfo(state) {
      state.info = null;
    },
    login(state){
      state.isLogin = true;
      state.isLoginUser.userName  =  sessionStorage.getItem('userName');

    },
    logout(){
      state.isLogin = false;
      state.isLoginUser.userName = null;
    },
    setLoadingShow(state,params){
      state.loadingShow = params;
    },
    setLogoutShow(state,params){
      state.logoutShow = params;
    }
  },

  actions: {
    putError(context, message) {
      context.commit('setError', message);
      setTimeout(() => {
        context.commit('clearError')
      }, 3000)
    },

    putInfo(context, message) {
      context.commit('setInfo', message);
      setTimeout(() => {
        context.commit('clearInfo')
      }, 3000)
    },
    loginActions(context){
      context.commit('login')
    },
    logoutActions(context){
      context.commit('logout')
    }
  },

  getters: {
    error(state) {
      return state.error;
    },
    info(state) {
      return state.info;
    }
  }
});

export default store;



// WEBPACK FOOTER //
// ./src/store/store.js